import { Link } from "react-router-dom";
import type { CatalogSituation } from "@/lib/catalog";
import { scenePartner } from "@/lib/sceneCast";
import {
  missionPracticePath,
  type FeaturedMission,
  type MissionStatus,
} from "@/lib/missions";
import { StatusDot } from "@/components/ui/status";
import { ListCard } from "@/components/ui/list-card";
import { cn } from "@/lib/utils";
import { ChevronRight } from "lucide-react";

export type ScenePathItem = {
  mission: FeaturedMission;
  scene: CatalogSituation;
  status: MissionStatus;
};

export const ScenePath = ({ items }: { items: ScenePathItem[] }) => (
  <ListCard>
    {items.map(({ mission, scene, status }, index) => (
      <Link
        key={mission.id}
        to={missionPracticePath(mission.id)}
        className={cn(
          "flex min-h-16 items-center gap-3 px-4 py-3",
          index > 0 && "border-t border-neutral-100",
        )}
      >
        <img
          src={scenePartner(scene).src}
          alt=""
          className="h-12 w-12 rounded-full object-cover object-[center_18%]"
        />
        <div className="min-w-0 flex-1">
          <p className="truncate text-body font-semibold text-neutral-900">{scene.title}</p>
          <p className="mt-0.5 text-body-sm text-neutral-500">{mission.placeTitle}</p>
        </div>
        <StatusDot status={status} />
        <ChevronRight className="h-5 w-5 text-neutral-400" strokeWidth={2} />
      </Link>
    ))}
  </ListCard>
);
